import React from 'react';
import theme from '@theme';

interface VegetarianIconProps {
  fill?: string;
}

const VegetarianIcon = ({ fill }: VegetarianIconProps) => {
  if (theme.name === 'ask') {
    return (
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.59717 4.17139H7.26574L8.45431 9.74853H8.47717L9.81431 4.17139H11.3915L9.35717 11.84H7.49431L5.59717 4.17139Z"
          fill={fill}
        />
        <path
          d="M8.49994 15.1657C12.4575 15.1657 15.6657 11.9575 15.6657 7.99994C15.6657 4.04243 12.4575 0.834229 8.49994 0.834229C4.54243 0.834229 1.33423 4.04243 1.33423 7.99994C1.33423 11.9575 4.54243 15.1657 8.49994 15.1657Z"
          stroke={fill}
          strokeWidth="0.75"
          strokeMiterlimit="10"
        />
      </svg>
    );
  }
  return (
    <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.48065 8.22645C5.54065 7.93642 5.60066 7.6664 5.66066 7.38637C5.82068 6.6663 5.9907 5.95623 6.13071 5.23616C6.36073 4.07605 6.56075 3.04595 6.78077 1.87583C6.81078 1.71582 6.84078 1.5558 6.88078 1.39579C6.91079 1.27578 6.98079 1.17577 7.20081 1.14576C7.42084 1.10576 8.70096 0.755725 9.56104 0.775727C9.74106 0.785728 9.79107 0.865736 9.85107 0.975747C9.97108 1.17577 10.1111 1.66581 10.0611 1.89584C10.0211 2.05585 9.99109 2.21587 9.95108 2.37588C9.61105 3.63601 9.27102 4.89613 8.94098 6.15625C8.84097 6.52629 8.75096 6.90632 8.65095 7.28636C8.50094 7.80641 8.35093 8.33646 8.14091 8.84651C7.91088 9.41657 7.81087 10.0266 7.67086 10.6167C7.53085 11.2167 7.32083 12.0168 7.0108 12.4369C6.70077 12.8669 6.52075 12.9769 6.32073 13.0469C6.11071 13.1069 5.90069 13.0869 5.22062 13.1469C4.54056 13.2069 4.66057 13.0969 4.37054 13.0469C4.07051 12.9969 3.87049 12.3869 3.66047 11.9868C3.47045 11.6168 3.29043 10.9467 3.13042 10.2266C3.00041 9.64659 2.83039 9.08654 2.63037 8.52648C2.46035 8.04643 2.31034 7.55639 2.18033 7.05634C1.77029 5.54619 1.50026 4.02604 1.10022 2.5059C1.06022 2.32588 1.02021 2.14586 0.970208 1.97584C0.910202 1.78583 0.940205 1.61581 1.00021 1.43579C1.09022 1.17577 1.99031 1.03575 2.39035 0.935743C2.78038 0.835733 3.56046 0.765726 3.75048 0.785728C3.86049 0.795729 3.9305 0.875737 3.9705 0.975747C3.9905 1.00575 4.0005 1.04575 4.0105 1.08576C4.20052 2.08585 4.40054 3.36598 4.60056 4.36608C4.84058 5.56619 5.09061 6.76631 5.34063 7.95643C5.35063 8.04643 5.36064 8.15644 5.48065 8.22645Z"
        fill={fill}
      />
    </svg>
  );
};

export default VegetarianIcon;
